<template>
    <Head>
        <title>Descargas - Ingenieros</title>
    </Head>

    <div>
        <section class="relative overflow-hidden bg-[#071226] px-4 pb-12 pt-10 text-white sm:px-6 lg:px-8">
            <div class="pointer-events-none absolute inset-0">
                <div class="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(37,99,235,0.18),transparent_30%)]"></div>
                <div class="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(249,115,22,0.12),transparent_30%)]"></div>
                <div class="absolute -left-20 top-0 h-72 w-72 rounded-full bg-orange-500/20 blur-3xl animate-pulse-slow"></div>
                <div class="absolute right-0 top-10 h-80 w-80 rounded-full bg-blue-500/20 blur-3xl animate-pulse-slow"></div>
            </div>

            <div class="relative mx-auto max-w-7xl">
                <p class="mb-3 inline-flex items-center rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-orange-300">
                    Panel interno
                </p>
                <h1 class="text-4xl font-black tracking-tight sm:text-5xl">Ingenieros</h1>
                <p class="mt-3 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
                    Consulta ingenieros y las marcas asociadas a cada perfil.
                </p>
            </div>
        </section>

        <div class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <div class="ts-table-wrap">
                <table class="ts-table">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Marca</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="engineerData in data" :key="engineerData.engineer?.id || engineerData.engineer?.name">
                            <td class="font-semibold text-slate-900">
                                {{ engineerData.engineer.name }}
                            </td>
                            <td>
                                <div class="flex flex-wrap items-center gap-3">
                                    <img
                                        v-for="brand in engineerData.brands"
                                        :key="brand.name"
                                        :src="brand.image"
                                        class="h-8 w-auto object-contain"
                                        :alt="brand.name"
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import BasePage from '@/Layouts/Base.vue';
import { Head } from '@inertiajs/inertia-vue3';

export default {
    layout: BasePage,
    components: {
        Head,
    },
    props: {
        data: Array | Object,
    },
};
</script>
